{
  "title": "Réinitialiser mot de passe",
  "subtitle": "Entrez votre e-mail pour un lien de réinitialisation",
  "emailLabel": "E-mail",
  "sendButton": "Envoyer le lien",
  "sendingButton": "Envoi...",
  "backToLogin": "Retour connexion",
  "successTitle": "Vérifiez votre e-mail",
  "successMessage": "Lien de réinitialisation envoyé à",
  "expiryNote": "Le lien expirera dans 1 heure",
  "errors": {
    "emailRequired": "Veuillez entrer votre adresse e-mail",
    "invalidEmail": "Veuillez entrer une adresse e-mail valide",
    "sendFailed": "Échec de l'envoi. Veuillez réessayer."
  }
}
